<template>
  <section>
    <v-container fluid>
      <!-- Breadcrumb and graphics -->
      <v-row style="min-height: 64px">
        <v-fade-transition>
          <v-col cols="auto" class="px-0" v-if="level > 1">
            <v-btn @click="backAction()" icon color="primary" fab small>
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
        </v-fade-transition>
        <v-fade-transition>
          <v-col v-if="level > 1" cols="auto" class="d-flex align-center">
            <v-breadcrumbs :items="breadcrumbItems" class="pa-0">
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  href="#"
                  @click="backAction(item.level)"
                  :disabled="item.disabled"
                >
                  <p
                    class="text-h6 mb-0"
                    :style="`color: ${item.disabled ? '#495057' : 'inherit'}`"
                  >
                    {{ item.text }}
                  </p>
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-col>
        </v-fade-transition>
        <v-col cols="auto" class="ml-auto">
          <v-switch
            v-model="isOpenGraph"
            inset
            class="mt-0"
            label="Ver gráficas"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>

      <!-- Search field -->
      <v-row class="justify-end align-center" style="min-height:68px">
        <v-col cols="auto">
          <v-btn
            @click="isActiveDownload = true"
            color="success"
            v-bind="attrs"
            v-on="on"
            small
            rounded
            fab
          >
            <v-icon>
              mdi-download
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-text-field
            filled
            rounded
            dense
            :value="searchField"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-card class="shadow-1 mt-5 mt-md-10">
        <!-- Table -->
        <v-data-table
          v-show="!isOpenGraph"
          :search="searchField"
          :headers="headers[level]"
          :items="tableList[level]"
          item-key="id"
          :loading="isLoading"
          :options.sync="tableOptions[level]"
          :server-items-length="totalItems[level]"
          no-data-text="No hay registros que mostrar"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100],
          }"
          :expanded.sync="itemsExpanded"
        >
          <template v-slot:[`item.action`]="{ item }">
            <v-hover v-if="item.surveys_count" v-slot:default="{ hover }">
              <v-btn
                text
                icon
                :color="hover ? 'accent' : 'blue-grey'"
                @click.stop="selectItem(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </v-hover>
            <v-hover
              v-if="item.contact && level === 3"
              v-slot:default="{ hover }"
            >
              <v-btn
                text
                icon
                :color="hover ? 'accent' : 'blue-grey'"
                @click.stop="toggleExpand(item)"
              >
                <v-icon v-if="itemsExpanded.find((el) => el.id === item.id)">
                  mdi-chevron-up
                </v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </v-btn>
            </v-hover>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row class="py-7">
                <v-col cols="12">
                  <v-row v-if="item.contact" justify="space-between">
                    <v-col cols="12" v-if="item.contact2">
                      <p class="text-subtitle-1 mb-0">Contacto 1</p>
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold"
                        >Nombre:</span
                      >
                      {{ item.contact.name }} {{ item.contact.lastNAme }}
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold">
                        Documento de identidad:
                      </span>
                      {{ item.contact.document || "No hay datos" }}
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold"
                        >Empresa:</span
                      >
                      {{ item.contact.business }}
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold"
                        >Telefono 1:</span
                      >
                      {{ item.contact.phone1 }}
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold"
                        >Telefono 2:</span
                      >
                      {{ item.contact.phone2 || "No hay datos" }}
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold"
                        >Whatsapp:</span
                      >
                      {{ item.contact.whatsapp || "No hay datos" }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12">
                  <v-row v-if="item.contact2" justify="space-between">
                    <v-col cols="12">
                      <p class="text-subtitle-1 mb-0">Contacto 2</p>
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold"
                        >Nombre:</span
                      >
                      {{ item.contact2.name }} {{ item.contact2.lastNAme }}
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold">
                        Documento de identidad:
                      </span>
                      {{ item.contact2.document || "No hay datos" }}
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold"
                        >Empresa:</span
                      >
                      {{ item.contact2.business }}
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold"
                        >Telefono 1:</span
                      >
                      {{ item.contact2.phone1 }}
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold"
                        >Telefono 2:</span
                      >
                      {{ item.contact2.phone2 || "No hay datos" }}
                    </v-col>
                    <v-col cols="4">
                      <span class="primary--text mr-3 font-weight-bold"
                        >Whatsapp:</span
                      >
                      {{ item.contact2.whatsapp || "No hay datos" }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </td>
          </template>
        </v-data-table>

        <!-- Gráficas -->
        <v-container v-show="isOpenGraph" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" md="5" v-if="isOpenGraph">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart5"
                    type="donut"
                    :options="optionsDonut"
                    :series="donutSeries[level]"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else-if="!isOpenGraph" cols="12" md="5">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>

            <v-col v-if="isOpenGraph" cols="12" md="6">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart7"
                    type="bar"
                    :options="optionsBar"
                    :series="barSeries[level]"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else cols="12" md="6">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <download-dialog
      v-if="isActiveDownload"
      :active="isActiveDownload"
      @dialog:close="isActiveDownload = false"
    ></download-dialog>
  </section>
</template>

<script>
const normalizeGraphicData = (data, level) => {
  switch (level) {
    case 2:
      let total = data.table
        .map((el) => el.surveys_count)
        .reduce((sum, el) => sum + el, 0);
      return {
        labels: data.table.map((el) => el.name),
        series: data.table.map((el) => el.surveys_count),
        totalSeries: total,
      };
    case 3:
      total = data.table
        .map((el) => el.total_register)
        .reduce((sum, el) => sum + el, 0);
      return data.table.reduce(
        (acc, el) => ({
          labels: [...acc.labels, el.date],
          series: [...acc.series, el.total_register],
          totalSeries: total,
        }),
        { labels: [], series: [] }
      );
    default:
      total = data
        .map((el) => el.surveys_count)
        .reduce((sum, el) => sum + el, 0);
      return {
        labels: data.map((el) => el.name),
        series: data.map((el) => el.surveys_count),
        totalSeries: total,
      };
  }
};
const getBarData = (arr) => {
  let log = arr.reduce((acc, el) => {
    const answerArr = el.answers.split(",");
    const mutateMap = new Map(acc);
    for (const [i, ans] of answerArr.entries()) {
      const current = mutateMap.get(`Pregunta ${i + 1}`) || {};
      mutateMap.set(`Pregunta ${i + 1}`, {
        ...current,
        [ans]: (current[ans] || 0) + el.total_register,
      });
    }
    return mutateMap;
  }, new Map());

  return [...log.values()]
    .map((serie) => ({
      "1": serie["1"] || 0,
      "2": serie["2"] || 0,
      "3": serie["3"] || 0,
      "4": serie["4"] || 0,
      "5": serie["5"] || 0,
    }))
    .reduce((acc, el) => {
      let mutateAcc = [...acc];
      for (const key in el) {
        if (mutateAcc.find((serie) => serie.name === `Respuesta ${key}`)) {
          mutateAcc = mutateAcc.map((serie) =>
            serie.name === `Respuesta ${key}`
              ? { ...serie, data: [...serie.data, el[key]] }
              : serie
          );
        } else {
          mutateAcc.push({ name: `Respuesta ${key}`, data: [el[key]] });
        }
      }
      return mutateAcc;
    }, []);
};
import { PbxHttpClient } from "@/services/httpclient";
import DownloadDialog from "@/components/DeepSurveys/DownloadDialog.vue";
export default {
  components: { DownloadDialog },
  data() {
    return {
      isActiveDownload: false,
      level: 1,
      searchField: null,
      isOpenGraph: false,
      isLoading: true,
      breadcrumbItems: [],
      itemsExpanded: [],
      epList: {
        1: "/surveys/report/register",
        2: `/surveys/report/register`,
        3: "/surveys/report/register/agent",
      },
      graphEpList: {
        1: "/surveys/report/graphi/register",
        2: `/surveys/report/graphi/agent`,
        3: "/surveys/report/graphi/agent",
      },
      optionsDonut: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },

        tooltip: {
          y: {
            formatter: (el) => `${el.toFixed(0)} %`,
          },
        },
        dataLabels: { enabled: false },
        labels: [],
      },
      optionsBar: {
        chart: { stacked: true },
        xaxis: {
          categories: [],
        },
      },
      headers: {
        1: [
          {
            text: "Nombre de cola",
            align: "left",
            value: "name",
            class: "primary--text",
            width: "40%",
          },
          {
            text: "Numero",
            value: "number",
            class: "primary--text",
            width: "25%",
          },
          {
            text: "Cantidad",
            value: "surveys_count",
            class: "primary--text",
            width: "25%",
          },
          {
            text: "Acciones",
            value: "action",
            class: "primary--text",
            width: "10%",
            align: "left",
            sortable: false,
          },
        ],
        2: [
          {
            text: "Nombre de Agente",
            align: "left",
            value: "name",
            class: "primary--text",
            width: "20%",
          },
          {
            text: "Extension",
            value: "extension",
            class: "primary--text",
            width: "20%",
          },
          {
            text: "Cantidad",
            value: "surveys_count",
            class: "primary--text",
            width: "30%",
          },
          {
            text: "Acciones",
            value: "action",
            class: "primary--text",
            width: "10%",
            align: "left",
            sortable: false,
          },
        ],
        3: [
          {
            text: "Nombre de Cola",
            align: "left",
            value: "queues.name",
            class: "primary--text",
            width: "20%",
          },
          {
            text: "Numero Cola",
            value: "queues.number",
            class: "primary--text",
            width: "15%",
          },
          {
            text: "Telefono",
            value: "origin",
            class: "primary--text",
            width: "20%",
          },
          {
            text: "ID Telefono",
            value: "contact.document",
            class: "primary--text",
            width: "20%",
          },
          {
            text: "Tipo de Llamada",
            value: "survey_name",
            class: "primary--text",
            width: "20%",
          },
          {
            text: "Respuestas",
            value: "answers",
            class: "primary--text",
            width: "20%",
          },
          {
            text: "Acciones",
            value: "action",
            class: "primary--text",
            width: "10%",
            align: "left",
            sortable: false,
          },
        ],
      },
      tableList: {
        1: [],
        2: [],
        3: [],
      },
      tableOptions: {
        1: {},
        2: {},
        3: {},
      },
      totalItems: {
        1: 0,
        2: 0,
        3: 0,
      },
      selected: {
        1: null,
        2: null,
        3: null,
      },
      donutSeries: { 1: [], 2: [], 3: [] },
      barSeries: {
        1: [{ name: "Cantidad", data: [] }],
        2: [{ name: "Cantidad", data: [] }],
        3: [{ name: "Cantidad", data: [] }],
      },
    };
  },

  created() {
    this.getGraphics();
  },

  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.getDataList();
      },
    },

    level(val, oldVal) {
      this.epList = {
        1: "/surveys/report/register",
        2: `/surveys/report/register/${this.selected[1]?.id}`,
        3: `/surveys/report/register/agent/${this.selected[1]?.id}/${this.selected[2]?.id}`,
      };

      this.graphEpList = {
        1: "/surveys/report/graphi/register",
        2: `/surveys/report/graphi/agent/${this.selected[1]?.id}`,
        3: `/surveys/report/graphi/agent/${this.selected[1]?.id}/${this.selected[2]?.id}`,
      };
      if (val > oldVal) {
        this.getDataList();
        this.getGraphics();
      } else this.cleanSelected();
    },
  },
  methods: {
    async getDataList() {
      const { page } = this.tableOptions[this.level] || 1;
      const itemPerPage = this.tableOptions[this.level].itemsPerPage || 15;
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get(this.epList[this.level], {
          params: { page, itemPerPage },
        });
        this.tableList[this.level] = data.data;
        this.totalItems[this.level] = data.total;
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoading = false;
    },
    async getGraphics() {
      try {
        const { data } = await PbxHttpClient.get(this.graphEpList[this.level]);
        const { labels, series, totalSeries } = normalizeGraphicData(
          data,
          this.level
        );
        // console.log(`arr level ${this.level}: `, normalizeGraphicData(data, this.level));
        this.optionsDonut.labels = labels;
        this.optionsBar.xaxis.categories = this.level !== 3 ? labels : [];
        this.donutSeries[this.level] = series.map(
          (el) => (el * 100) / totalSeries
        );
        this.barSeries[this.level] =
          this.level !== 3
            ? [{ name: "Cantidad", data: series }]
            : getBarData(data.answer);
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
    },
    backAction(selectedLevel = false) {
      this.level = selectedLevel || this.level - 1;
      this.breadcrumbItems = selectedLevel
        ? this.breadcrumbItems.slice(0, selectedLevel - 1)
        : this.breadcrumbItems.slice(0, -1);
    },
    selectItem(item) {
      this.selected[this.level] = item;
      this.level += 1;
      this.generateBreadcrumb();
    },
    cleanSelected() {
      Object.keys(this.selected).map((key) => {
        if (key >= this.level) {
          this.selected[key] = null;
          this.tableOptions[key] = {};
        }
      });
    },
    generateBreadcrumb() {
      this.breadcrumbItems = [];
      Object.keys(this.selected).map((key) => {
        if (!this.selected[key]) return;
        this.breadcrumbItems = [
          ...this.breadcrumbItems,
          {
            text: this.selected[key].name,
            level: Number(key),
            disabled: this.level - 1 === Number(key),
          },
        ];
      });
    },
    toggleExpand(item) {
      if (this.itemsExpanded.find((el) => el.id === item.id))
        this.itemsExpanded = this.itemsExpanded.filter(
          (el) => el.id !== item.id
        );
      else this.itemsExpanded = [...this.itemsExpanded, item];
    },
  },
};
</script>

<style></style>
